// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 客户投诉与建议 POST /customer/complaint */
export async function customerComplaintUsingPOST(
  body: API.CustomerComplaintReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/customer/complaint', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
